import { useMachine } from 'lib/hooks/useMachine';
import { useProgramEventDisplayState } from 'lib/hooks/useProgramEventDisplayState';
import { useRequestFAIStatus } from 'lib/hooks/useRequestFAIStatus';
import { useRealTimeData } from './useRealTimeData';
import { useInitialData } from './useInitialData';
import { useAnnotations } from './useAnnotations';
import { useSetupData } from './useSetupData';
import { useWorkflowWatcher } from './useWorkflowWatcher';
import { useFAIData } from './useFAIData';
import { useStatusIntervalsResync } from './useStatusIntervalsResync';
// import { useStreamReader } from './useStreamReader';

const useData = () => {
  useMachine();
  useAnnotations();
  const {
    resyncForCategorize,
    resyncAfterRecovery,
    noteExecutionError,
  } = useStatusIntervalsResync();
  useRealTimeData({
    onExecutionRecovered: resyncAfterRecovery,
    onExecutionError: noteExecutionError,
  });
  useSetupData();
  useWorkflowWatcher();
  useRequestFAIStatus();
  useFAIData();
  // useStreamReader(); //TODO (Paul): Make a new StreamReader (Nats Client Consumer)
  useProgramEventDisplayState();
  const { refetch } = useInitialData();

  return { refetch, resyncForCategorize };
};

export { useData };
